/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';
import { CartItem } from './cart-item';
import { Discount } from './discount';
import { ObjectId } from './object-id';
import { OrderTimeLineDTO } from './order-time-line-dto';
import { PreferedPickOrDeliveryTimeDto } from './prefered-pick-or-delivery-time-dto';
import { ShippingInfo } from './shipping-info';
import { UserWithNoId } from './user-with-no-id';
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    id: string;
    /**
     * 
     * @type {ObjectId}
     * @memberof Order
     */
    userId: ObjectId;
    /**
     * 
     * @type {ObjectId}
     * @memberof Order
     */
    payment: ObjectId;
    /**
     * 
     * @type {Array<string>}
     * @memberof Order
     */
    refunds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    orderType: OrderOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    orderStatus: string;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof Order
     */
    items: Array<CartItem>;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    subTotal: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    shippingCost: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    grandTotal: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    discountedAmount: number;
    /**
     * 
     * @type {ShippingInfo}
     * @memberof Order
     */
    shippingInfo: ShippingInfo;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    notes: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    storeId: string;
    /**
     * 
     * @type {Array<OrderTimeLineDTO>}
     * @memberof Order
     */
    orderTimeLine: Array<OrderTimeLineDTO>;
    /**
     * 
     * @type {UserWithNoId}
     * @memberof Order
     */
    userData: UserWithNoId;
    /**
     * 
     * @type {Discount}
     * @memberof Order
     */
    discountsApplied: Discount;
    /**
     * 
     * @type {Address}
     * @memberof Order
     */
    pickUpAddress: Address;
    /**
     * 
     * @type {PreferedPickOrDeliveryTimeDto}
     * @memberof Order
     */
    preferedPickOrDeliveryTime: PreferedPickOrDeliveryTimeDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof Order
     */
    orderRemindingDates: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Order
     */
    customProducts: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    type: OrderTypeEnum;
    /**
     * Shippo rate ID stored for deferred label purchase on Card payments
     * @type {string}
     * @memberof Order
     */
    shippoRateId: string;
    /**
     * Whether to send an order confirmation email to the customer. Persisted so the invoice.paid webhook can respect it.
     * @type {boolean}
     * @memberof Order
     */
    sendConfirmationEmail: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderOrderTypeEnum {
    Pickup = 'Pickup',
    Delivery = 'Delivery'
}
/**
    * @export
    * @enum {string}
    */
export enum OrderTypeEnum {
    Quotation = 'Quotation',
    Order = 'Order'
}

